<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#ee0909"
  type="ball-atom"
  [fullScreen]="true"
>
  <p style="color: white">cargando ....</p>
</ngx-spinner>

<ng-container>
  <div class="container">
    <br />
    <div class="panel panel-danger">
      <div class="panel-heading">
        <p class="encabezado">Comité</p>
      </div>
      <br />

      <div class="container">
        <h1 class="h1_tittle">Datos generales</h1>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Sector productivo:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{ details?.sectorProductivoStr ? details.sectorProductivoStr : "N/A" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Nombre:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{ details?.nombre ? details.nombre : "N/A" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Presidente:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{ details?.presidente ? details.presidente : "N/A" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Puesto de presidente:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.puestoPresidente
                          ? details.puestoPresidente
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Vicepresidente:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.vicepresidente ? details.vicepresidente : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Puesto de vicepresidente:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.puestoVicepresidente
                          ? details.puestoVicepresidente
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Fecha de integración:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.fechaIntegracion
                          ? details.fechaIntegracion
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <h1 class="h1_tittle">Dirección</h1>
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Calle y Número:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.calleNumero &&
                        details?.calleNumero !== "" &&
                        details?.calleNumero !== " "
                          ? details.calleNumero
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Colonia:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.colonia &&
                        details?.colonia !== "" &&
                        details?.colonia !== " "
                          ? details.colonia
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Delegación:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.delegacionStr &&
                        details?.delegacionStr !== "" &&
                        details?.delegacionStr !== " "
                          ? details.delegacionStr
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-4">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Entidad Federativa:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.entidadStr &&
                        details?.entidadStr !== "" &&
                        details?.entidadStr !== " "
                          ? details.entidadStr
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-4">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Código Postal :</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.codigoPostal &&
                        details?.codigoPostal !== "" &&
                        details?.codigoPostal !== " "
                          ? details.codigoPostal
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />

      <div class="container">
        <h1 class="h1_tittle">Contacto</h1>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4">

    
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Contacto:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.contacto &&
                        details?.contacto !== "" &&
                        details?.contacto !== " "
                          ? details.contacto
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Teléfono:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.telefonos &&
                        details?.telefonos !== "" &&
                        details?.telefonos !== " "
                          ? details.telefonos
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-4">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">E-mail:</p>
                  </div>
                  <div class="col-sm-12">
                    <div *ngIf="emailList.length > 0; else noEmails">
                      <div *ngFor="let email of emailList">
                        <p class="letra">{{ email }}</p>
                      </div>
                    </div>
                    <ng-template #noEmails>
                      <p class="letra">N/A</p>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />
      <div class="container" *ngIf="details?.estandaresAsociados?.length > 0">
        <h1 class="h1_tittle">Estándares de competencias laborales</h1>
      </div>

      <div
        class="table-container"
        *ngIf="details?.estandaresAsociados?.length > 0"
      >
        <table>
          <thead>
            <tr>
              <th>Código</th>
              <th>Título</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of details?.estandaresAsociados">
              <td>{{ item.codigo }}</td>
              <td>{{ item.titulo }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <br />
      <br />

      <div class="row">
        <div class="container">
          <div class="col-sm-5"></div>
          <div style="text-align: center" class="col-sm-1">
            <button mat-button (click)="close()">
              <img src="./assets/images/icon/Atras.png" class="imagen" />
            </button>
          </div>
          <div style="text-align: center" class="col-sm-1">
            <button mat-button (click)="close()">
              <img src="./assets/images/icon/Home.png" class="imagen" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
